/**
 * Login-screen icons, kept inline rather than pulled from an icon package so
 * the login route (which renders before any app chunk loads) stays small.
 * Shapes match Lucide / Provider Portal's onboarding login.
 */

export function ProviderIcon({
  id,
  size = 20,
}: {
  id: "entra" | "pathways-b2c" | "provider-portal-b2c";
  size?: number;
}) {
  if (id === "entra") {
    return (
      <img
        src="/images/microsoft-icon.svg"
        alt=""
        aria-hidden="true"
        className="shrink-0"
        style={{ width: size, height: size }}
      />
    );
  }
  // Generic id-card glyph for B2C — one asset fewer to ship per provider.
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className="shrink-0"
    >
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M7 10h4M7 14h6" />
      <circle cx="16" cy="12" r="2" />
    </svg>
  );
}

/**
 * Entra's tile/button icon as an inline SVG rather than the `<img>` above.
 * `currentColor` lets it inherit the tile's hover/focus colour, which an
 * `<img>` cannot do.
 */
export function MicrosoftGlyph({ size = 20 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      className="shrink-0"
    >
      <path d="M2 3h9v9H2V3m9 19H2v-9h9v9M21 3v9h-9V3h9m0 19h-9v-9h9v9Z" />
    </svg>
  );
}

export function EyeIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}

export function EyeOffIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24" />
      <path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68" />
      <path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61" />
      <line x1="2" y1="2" x2="22" y2="22" />
    </svg>
  );
}

export function Spinner() {
  return (
    <div
      className="w-7 h-7 rounded-full border-[3px] border-border border-t-primary animate-spin"
      aria-hidden="true"
    />
  );
}
